const Warning = () => (
  <svg
    width="132"
    height="124"
    viewBox="0 0 132 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M70.6036 46.4988V65.8738M23.0056 83.3145C18.578 91.0645 24.1168 100.749 32.9768 100.749H108.23C117.09 100.749 122.629 91.0645 118.202 83.3145L80.5748 17.4524C76.1448 9.69814 65.0624 9.69814 60.6324 17.4524L23.0056 83.3145ZM70.6036 81.3738H70.642V81.4126H70.6036V81.3738Z"
      stroke="#0F172A"
      strokeWidth="5.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.9338 23.591C51.076 12.8412 66.5761 12.8412 72.7183 23.591L108.996 87.0839C115.091 97.7504 107.389 111.022 95.1043 111.022H22.5478C10.263 111.022 2.56103 97.7504 8.6556 87.0839L44.9338 23.591Z"
      fill="#6600FF"
      fillOpacity="0.2"
    />
  </svg>
);

export default Warning;
